function none() {}

export default function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-selection/src/selector.js
// module id = zPLX
// module chunks = 0